import { useContext } from 'react';
import { useSelector } from 'react-redux';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import { getIframeReady } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { SECTIONS_LIBRARY_TOUR } from 'ContentEditorUI/constants/tours';
export function useStartSectionsLibraryOnboardingTour() {
  const {
    tour
  } = useContext(TourContext);
  const iframeReady = useSelector(getIframeReady);
  const activeTour = tour.getTour();
  const isActiveTour = activeTour === SECTIONS_LIBRARY_TOUR;
  const isAnyOtherTourActive = activeTour !== null && !isActiveTour;
  const shouldStartTour = iframeReady && !isActiveTour && !isAnyOtherTourActive;
  const startTour = () => {
    if (!shouldStartTour) {
      return;
    }
    tour.activate(SECTIONS_LIBRARY_TOUR);
    tour.start();
  };
  return {
    startTour
  };
}